import React from 'react'
import { IconButton } from './IconButton'
import type { IconName } from '../../../shared/webcomponents/helpers/icons'

export interface BottomSheetOptionProps {
    optionLabel: string
    labelStyles?: React.CSSProperties
    testId?: string
    iconName: IconName
    onClick: () => void
}

function BottomSheetOption(props: BottomSheetOptionProps) {
    const { optionLabel, labelStyles, iconName, onClick, testId } = props

    return (
        <div className="AppCore__BottomSheetOption-item" onClick={onClick} data-testid={testId}>
            <span>
                <IconButton border={false} iconName={iconName} size="small" />
            </span>
            <span style={labelStyles}>{optionLabel}</span>
        </div>
    )
}

interface BottomSheetOptionsProps {
    options: BottomSheetOptionProps[]
}

export function BottomSheetOptions(props: BottomSheetOptionsProps) {
    const { options } = props

    return (
        <div className="AppCore__BottomSheetOptions-wrapper">
            {options.map((option, index) => (
                <BottomSheetOption key={index} {...option} />
            ))}
        </div>
    )
}
